import React, { useEffect, useState } from 'react'
import PageBanner from 'components/Luxkit/Banners/PageBanner'
import { useTranslation } from 'react-i18next'

function CookiesDisabledWarning() {
  const [areCookiesEnabled, setCookiesAreEnabled] = useState<boolean>(true)
  const { t } = useTranslation('common')

  useEffect(() => {
    if (window.navigator.cookieEnabled) {
      setCookiesAreEnabled(true)
    } else {
      document.cookie = 'cookietest=1'
      setCookiesAreEnabled(document.cookie.includes('cookietest='))
      document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT'
    }
  }, [])

  if (areCookiesEnabled) {
    return null
  }

  return <PageBanner
    kind="warning"
    align="center"
    description={t('disabledCookies')}
  />
}

export default CookiesDisabledWarning
